module.exports = __webpack_public_path__ + "static/media/ic_caret_down_blue.c9a505db.svg";